import { useState } from 'react'
import { Sparkles, Copy, Check } from 'lucide-react'
import { trackSegmentEvent } from '../lib/segment'
import { AGENT_PROMPT } from '../lib/docs'
// np-prompt styling lives in StartQaForm.css.
import './StartQaForm.css'

export function useAgentPromptCopy() {
  const [copied, setCopied] = useState(false)
  async function copy() {
    try {
      await navigator.clipboard.writeText(AGENT_PROMPT)
    } catch {
      /* clipboard unavailable */
    }
    trackSegmentEvent('Copied agent prompt')
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }
  return { copied, copy }
}

export function AgentPromptBox({ copied, onCopy, analyticsEvent, prompt = AGENT_PROMPT }: { copied: boolean; onCopy: () => void; analyticsEvent: string; prompt?: string }) {
  return (
    <div className="np-prompt">
      <div className="np-prompt__bar">
        <span className="np-prompt__label">
          <Sparkles size={13} strokeWidth={1.75} aria-hidden /> Agent prompt
        </span>
        <button
          type="button"
          className={`np-prompt__copy${copied ? ' np-prompt__copy--done' : ''}`}
          onClick={onCopy}
          data-testid="agent-copy-btn"
          data-analytics-event={analyticsEvent}
          aria-label={copied ? 'Copied' : 'Copy prompt'}
          title={copied ? 'Copied' : 'Copy prompt'}
        >
          {copied ? <Check size={14} strokeWidth={1.75} aria-hidden /> : <Copy size={14} strokeWidth={1.75} aria-hidden />}
        </button>
      </div>
      {/* Shown in full: the prompt is short, and clamping it behind an expander hides the thing the
          user came for. */}
      <div className="np-prompt__body">
        <pre className="np-prompt__text" data-testid="agent-prompt">
          {prompt}
        </pre>
      </div>
    </div>
  )
}

// The copyable agent prompt for surfaces that hand Replay QA to the user's coding agent.
export function AgentPrompt({ analyticsEvent }: { analyticsEvent: string }) {
  const { copied, copy } = useAgentPromptCopy()
  return <AgentPromptBox copied={copied} onCopy={copy} analyticsEvent={analyticsEvent} />
}
